import React, { Fragment, FunctionComponent } from 'react';
import styles from './Projects.module.scss';
import { Block, BlockContent, Image, Link, ResponsiveImage, Typography } from 'components/elements';
import { WPAcfProjects } from 'types/acf/projects';
import DOMPurify from 'dompurify';

interface OwnProps {
  data: WPAcfProjects | null;
}

type ProjectsProps = JSX.IntrinsicElements['div'] & OwnProps;

const Projects: FunctionComponent<ProjectsProps> = props => {
  const { data } = props;

  if (!data || !data.items?.length) {
    return null;
  }

  const { items } = data;

  return (
    <Fragment>
      {items.map((item, index) => {
        const { image, description, header, logos, subheader, buttonLabel, buttonLink } = item;

        return (
          <Block id={`project-${index}`} key={`project-item-${index}`} theme="light" data-module="project">
            <BlockContent direction="row">
              <div className={styles.image}>
                <ResponsiveImage desktopImage={{ config: image }} mobileImage={{ config: image }} />
              </div>
              <div className={styles.content}>
                {header && (
                  <Typography className={styles.header} mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" as="h3">
                    {header}
                  </Typography>
                )}
                {subheader && (
                  <Typography className={styles.subheader} mobile="new_neue_16" tablet="new_neue_16" desktop="new_neue_16" as="h4">
                    {subheader}
                  </Typography>
                )}
                {description && (
                  <Typography
                    className={styles.description}
                    mobile="new_ibm_regular_16"
                    tablet="new_ibm_regular_16"
                    desktop="new_ibm_regular_16"
                    as="div"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
                  />
                )}
                {buttonLabel && buttonLink && (
                  <Link className={styles.link} href={buttonLink}>
                    {buttonLabel}
                  </Link>
                )}
                {logos && (
                  <div className={styles.logos}>
                    {logos.map((logo, index) => {
                      if (!logo) {
                        return null;
                      }
                      return (
                        <div className={styles.logo} key={`white-logo-desktop-${index}`}>
                          {/* TODO: Responsive check */}
                          <Image width={2} height={1} sizes="10vw" acfConfig={logo} />
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </BlockContent>
          </Block>
        );
      })}
    </Fragment>
  );
};

export default Projects;
